import { iframeResizer } from 'iframe-resizer'
window.addEventListener('load', function () {
  iframeResizer({log: false}, '.checkcherry-autoresize-frame')
}, false);
